import { connect } from 'react-redux';
import Header from './Header.jsx';
import { getUserId, getDefaultPicture, getIsUserListerSelector } from 'datamodel/User/selectors';
import AuthActions from 'datamodel/Auth/actions';
import UserActions from 'datamodel/User/actions';
import RequirementsActions from 'datamodel/Requirements/actions';
import { locale } from 'base/shared/Localization';

const mapStateToProps = (state) => ({
  isLoggedIn: !!state.User.id,
  userId: getUserId(state),
  picture: getDefaultPicture(state),
  isLister: getIsUserListerSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(AuthActions.logout()),
  switchUser: (mode) => dispatch(UserActions.setUserMode({ mode, isActiveSwitching: true })),
  openLogin: () => {
    console.log('openLogin called, dispatching RequirementsActions.setLogin(true)');
    dispatch(RequirementsActions.setLogin(true));
  },
  openMyProfile: () => (window.location.href = '/my-profile'),
  onListYourProperty: () => {
    // Navegar a la página correcta según el idioma
    const currentLocale = locale();
    const url =
      currentLocale === 'es' ? 'https://badi.com/es/anunciantes' : 'https://badi.com/listers';
    window.open(url, '_blank');
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
